var o = (n, e, r) => new Promise((s, g) => {
  var c = (t) => {
    try {
      a(r.next(t));
    } catch (i) {
      g(i);
    }
  }, d = (t) => {
    try {
      a(r.throw(t));
    } catch (i) {
      g(i);
    }
  }, a = (t) => t.done ? s(t.value) : Promise.resolve(t.value).then(c, d);
  a((r = r.apply(n, e)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function f(n) {
  return o(this, null, function* () {
    const {
      data: e
    } = yield m.get(
      "/designordercenterapi/internal/customerOrderCommon/getBrandListByOrgMarketManageRight",
      { params: n }
    );
    return e == null ? void 0 : e.data;
  });
}
export {
  f as getGetBrandListByOrgMarketManageRight
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/internal/customerOrderCommon/getBrandListByOrgMarketManageRight/get.js
// module id = 1809
// module chunks = 67